import moment, { Moment } from "moment";

const DATE_INPUT_FORMATS = [
  "M/D/YY",
  "MM/DD/YY",
  "M/D/YYYY",
  "MM/DD/YYYY",
  "YYYY/M/D",
  "YYYY/MM/DD",
  "MMMM D, YY",
  "MMMM D YY",
  "MMMM D, YYYY",
  "MMMM D YYYY",
  "MMMM Do, YYYY",
  "MMMM Do YYYY",
  "MMM D, YY",
  "MMM D YY",
  "MMM D, YYYY",
  "MMM D YYYY",
  "MMM Do, YYYY",
  "MMM Do YYYY",
  "D MMMM YY",
  "D MMMM YYYY",
  "Do MMMM YYYY",
  "D MMM YY",
  "D MMM YYYY",
  "Do MMM YYYY",
];

export const parseDateInput = (input: string): Moment => {
  const trimmedInput = input.trim();
  const compactNumericDate = trimmedInput.match(/^\d{6}(?:\d{2})?$/);
  const separatedNumericDate = trimmedInput.match(/^(\d{1,4})[\/\.\-\s]+(\d{1,2})[\/\.\-\s]+(\d{1,4})$/);
  const normalizedInput = compactNumericDate
    ? `${trimmedInput.slice(0, 2)}/${trimmedInput.slice(2, 4)}/${trimmedInput.slice(4)}`
    : separatedNumericDate
    ? separatedNumericDate.slice(1).join("/")
    : trimmedInput.replace(/^sept(?=\s)/i, "Sep");

  return moment(normalizedInput, DATE_INPUT_FORMATS, true);
};
